/*
 *		Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accEsignatureActions', ['$translate', 'template', 'confirmAction', 'operationComplete', 'flashMessagesService',
        function ($translate, template, confirmAction, operationComplete, flashMessagesService) {
            return {
                scope: {
                    esignature: '<'
                },
                replace: true,
                templateUrl: template('signed_files/_esignature_actions'),
                controller: ['$scope', function ($scope) {
                    $scope.delete = function (esignature) {
                        const submitButtonText = $translate.instant('signed_files_page_delete_esignature_confirmation_submit');
                        let titleText;

                        if (esignature.isSigned) {
                            titleText = $translate.instant('signed_files_page_delete_esignature_signed_confirmation_title');
                        } else {
                            titleText = $translate.instant('signed_files_page_delete_esignature_in_progress_confirmation_title');
                        }

                        confirmAction($scope, {
                            confirmTitle: titleText,
                            confirmBodyTemplate: 'modals/actions/confirm_delete_esignature',
                            confirmSubmit: submitButtonText,
                            confirmSubmitClass: 'btn-danger',
                            onOpen: () => {
                                if (esignature.isSigned) {
                                    flashMessagesService.add(
                                        $translate.instant('signed_files_page_delete_esignature_signed_confirmation_warning'),
                                        flashMessagesService.NOTICE
                                    );
                                }
                            },
                            onConfirm: () => {
                                return esignature.$delete(
                                    {action: esignature.uuid},
                                    function () {
                                        $scope.$emit('reload.document', esignature.mainItem);

                                        operationComplete('Operation successful.');
                                    }
                                )
                            },
                            modalUpdate: (modalScope) => {
                                modalScope.esignature = esignature;
                                modalScope.confirmations = {};

                                modalScope.disableSubmit = () => {
                                    return Object.values(modalScope.confirmations).some((confirmation) => confirmation !== true);
                                }
                            }
                        });
                    }
                }]
            };
        }
    ]);
